import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import {
	bulkDelete,
	constructEntityList,
	constructEntityListSuccess,
	deleteEntity,
	deleteEntityFail,
	fetchEntityListFail,
	fetchEntityListSuccess,
	fetchPublicProjectDetails,
	fetchPublicProjectDetailsSuccess,
	persistenceActionFinish,
	persistEntityStarted,
	persistEntityStopped,
	refreshEntityList,
	repersistEntityStarted,
	repersistEntityStopped,
	trackAction,
	unpersistEntityStarted,
	unpersistEntityStopped,
	updateEntitiesFrameStatusSuccess,
	updateIncludePublic,
} from './entity.actions';
import { EntityOriginalSliceState } from './entity.state';

export const entityOriginalReducer = createReducer<EntityOriginalSliceState>(
	new EntityOriginalSliceState(),
	on(goToProjects, setProject, (state) => state.clear()),
	on(constructEntityList, refreshEntityList, (state) => state.setLoading(true)),
	on(fetchEntityListFail, (state) => state.setLoading(false)),
	on(constructEntityListSuccess, (state, action) =>
		state.setEntityList(action.entityList)
	),
	on(fetchEntityListSuccess, (state, action) =>
		state.setLoading(false).setEntityList(action.entityList)
	),
	on(updateIncludePublic, (state, action) =>
		state.setLoading(true).toggleIncludePublicProjects(action.includePublic)
	),
	on(
		persistEntityStarted,
		repersistEntityStarted,
		unpersistEntityStarted,
		(state, action) =>
			state.setEntityList(
				state.list.setActionInProgress(action.entityId, true, action.jobId)
			)
	),
	on(
		persistEntityStopped,
		unpersistEntityStopped,
		repersistEntityStopped,
		(state, action) =>
			state.setEntityList(
				state.list.setActionInProgress(action.entityId, false, action.jobId)
			)
	),
	on(trackAction, (state, action) =>
		state.setEntityList(state.list.setJobId(action.entityId, action.jobId))
	),
	on(persistenceActionFinish, (state, action) =>
		state.setEntityList(
			state.list
				.updatePersistenceInfo(action.entityId, action.persistenceInfo)
				.setJobId(action.entityId, null)
		)
	),
	on(fetchPublicProjectDetails, (state) =>
		state.setIsLoadingPublicProjectDetails(true)
	),
	on(fetchPublicProjectDetailsSuccess, (state, action) =>
		state
			.setIsLoadingPublicProjectDetails(false)
			.setEntityList(
				state.list.updateItem(
					action.entityId,
					action.characCount,
					action.depotCount
				)
			)
	),
	on(updateEntitiesFrameStatusSuccess, (state, action) =>
		state.setEntityList(action.entityList)),
	on(deleteEntity, bulkDelete, (state) => state.setLoading(true)),
	on(deleteEntityFail, (state) => state.setLoading(false))
);
